let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eVVh2")).then(() => parcelRequire('57upj'));